import { computed, inject } from '@angular/core';
import { selectPresetValue } from '@epicuro-next/state/p-basket-state';
import { concatLatestFrom } from '@ngrx/operators';
import { signalStore, withComputed, withMethods } from '@ngrx/signals';
import { rxMethod } from '@ngrx/signals/rxjs-interop';
import { select, Store } from '@ngrx/store';
import {
  PanelStyle,
  PanelType,
  RecommendedItemProducts,
  SimilarProductsProperties,
} from 'models-recommendation';
import { mapProductV2 } from 'product-mapping';
import { filter, map, pipe, tap } from 'rxjs';

import { withSuggestProducts } from './shared/suggest-products-store-feature';

const panelType = PanelType.SuggestedProducts;
// tslint:disable-next-line:variable-name
export const SimilarProductsStore = signalStore(
  withSuggestProducts<RecommendedItemProducts, SimilarProductsProperties>(
    panelType,
    PanelStyle.ExtendedSimilarProducts,
  ),
  withComputed((state) => ({
    items: computed(() =>
      state.result.dataSet().map(({ item }) => mapProductV2(item)),
    ),
  })),
  withMethods((state, store = inject(Store)) => {
    return {
      loadSimilarProducts: rxMethod<{ productId: string; brandId: string }>(
        pipe(
          concatLatestFrom(() => [
            store.pipe(
              select(selectPresetValue),
              map((v) =>
                !!v && ['future', 'now', 'any'].includes(v.toLowerCase())
                  ? v
                  : 'any',
              ),
              filter((v): v is 'future' | 'now' | 'any' => !!v),
            ),
          ]),
          tap(([{ productId, brandId }, orderType]) => {
            return state.loadSuggestProducts({
              productIdsCsv: productId,
              brandId,
              orderType,
            });
          }),
        ),
      ),
    };
  }),
);
